import {METHOD, STORAGE_KEY} from "utils/constants";

const gstarFetchRequest = ({path, method, params, queryParams, isMockRequest}) => {
  const headers = {"Content-Type": "application/json; charset=utf-8", Accept: "application/json;"};

  if (localStorage.getItem("redbrickToken")) {
    headers["Authorization"] = `Bearer ${localStorage.getItem(STORAGE_KEY.REDBRICK_TOKEN)}`;
  }

  let url = "https://api-gstar-event.redbrick.land" + path;
  if (queryParams) url += "?" + new URLSearchParams(queryParams).toString();

  return fetch(url, {
    headers,
    method,
    body: JSON.stringify(params),
  })
    .then(res => res.json())
    .then(data => {
      return data;
    });
};

const request = {
  get(requestInfo) {
    return gstarFetchRequest({method: METHOD.GET, ...requestInfo});
  },
  post(requestInfo) {
    return gstarFetchRequest({method: METHOD.POST, ...requestInfo});
  },
  put(requestInfo) {
    return gstarFetchRequest({method: METHOD.PUT, ...requestInfo});
  },
  patch(requestInfo) {
    return gstarFetchRequest({method: METHOD.PATCH, ...requestInfo});
  },
  delete(requestInfo) {
    return gstarFetchRequest({method: METHOD.DELETE, ...requestInfo});
  },
};

export const createRank = params => {
  return request.post({
    path: "/record",
    params,
  });
};

export const getUserInfo = params => {
  return request.post({
    path: "/user/info",
    params,
  });
};

export const getRankList = params => {
  return request.post({
    path: "/rank/list",
    params,
  });
};

export const aggregateRank = params => {
  return request.post({
    path: "/rank/aggregate",
    params,
  });
};

export const checkCode = params => {
  return request.post({
    path: "/event/code/check",
    params,
  });
};

export const getCode = params => {
  return request.post({
    path: "/event/code/info",
    params,
  });
};

export const updateCode = params => {
  return request.post({
    path: "/event/code/update",
    params,
  });
};
